import React, { useEffect } from "react";
import AOS from "aos";
import abCover from "./../assets/about/abCover.jpg";
import commitment from "./../assets/about/commitment.jpg";
import { Link } from "react-router-dom";

const About = () => {
  useEffect(() => {
    AOS.init({ duration: 1200 });
  }, []);

  return (
    <div>
      {/* About Us Section */}
      <h1 className="text-4xl md:text-7xl text-center leading-8 font-montserrat font-medium tracking-widest p-12 md:p-32">
        ABOUT US
      </h1>

      {/* Section 1 */}
      <div className="flex flex-col justify-center pt-12 bg-white">
        <div className="bg-[#F1F1F1] relative flex flex-col md:flex-row md:space-x-5 space-y-3 md:space-y-0 p-0 max-w-sm md:max-w-6xl mx-auto">
          <div className="w-full md:w-2/4 grid place-items-center">
            <img
              src={abCover}
              alt="About Cover"
              className="object-cover w-full"
            />
          </div>
          <div className="bg-[#F1F1F1] w-full md:w-2/4 md:pt-20 pt-2 p-6 flex flex-col space-y-2 md:p-10">
            <h3 className="font-montserrat font-semibold text-black text-left pb-3 md:text-xl text-lg tracking-wide">
              WHO WE ARE
            </h3>
            <p className="text-left leading-8 md:text-base font-montserrat font-medium tracking-narrow">
              Welcome to Astra Concepts, where luxury and functionality merge in
              outdoor living. Specializing in high-end aluminum pergolas and
              shading systems, we aim to transform your backyard into a stylish
              relaxation haven. <br />
              <br />
              Our products, ranging from modern to classic designs, embody
              durability, weather resistance, and aesthetic appeal, reflecting
              our commitment to quality and detail. At Astra Concepts, we view
              your outdoor space as a potential masterpiece, with our pergolas
              as the central art. Driven by precision and innovation, we cater
              to diverse tastes, ensuring that each design aligns with our
              clients' dreams, redefining luxury in every backyard.
              <br />
              <br />
              At Astra Concepts, we take pride in carrying forward the same values and principles that define our sister company, Varsa Windows and Doors. 
  With a shared commitment to quality, innovation, and customer satisfaction, we bring the same dedication to excellence in every project we undertake. 
            </p>
          </div>
        </div>
      </div>

      {/* Section 3 */}

      <h2 className="text-4xl md:text-6xl text-center leading-8 font-montserrat font-medium tracking-wide md:tracking-widest pt-24 md:pt-32">
        OUR PROCESS
      </h2>

      <div className="flex flex-wrap justify-center bg-white pt-24 md:pt-32">
        <div className="max-w-sm md:max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="flex flex-col items-center text-center p-6 bg-[#F1F1F1] ">
            <span className="font-montserrat font-bold text-center pt-6 text-lg tracking-wide">
              DESIGN
            </span>
            <p className="text-left leading-8 font-montserrat font-medium text-md tracking-narrow pt-5">
              We first meet with you to gather a complete understanding of your
              vision, taking into account the site location, features, and
              projected budget.
            </p>
          </div>

          <div className="flex flex-col items-center text-center p-6 bg-[#F1F1F1] ">
            <span className="font-montserrat font-bold text-center pt-6 text-lg tracking-wide">
              BUILD
            </span>
            <p className="text-left leading-8 font-montserrat font-medium text-md tracking-narrow pt-5">
              At Astra we turn your approved plans into a reality by carefully
              managing every detail. Our hands-on approach ensures execution of
              your vision.
            </p>
          </div>

          <div className="flex flex-col items-center text-center p-6 bg-[#F1F1F1] ">
            <span className="font-montserrat font-bold text-center pt-6 text-lg tracking-wide">
              INSTALL
            </span>
            <p className="text-left leading-8 font-montserrat font-medium text-md tracking-narrow pt-5">
              Whether you need materials supplied or a full install, we’re here
              to help. Our transparent, precise process ensures a stunning
              outcome while keeping your vision front and center.
            </p>
          </div>
        </div>
      </div>

      {/* Section 3 */}
      <div className="flex flex-col justify-center pt-24 md:pt-32 pb-12 md:pb-32 bg-white">
        <div className="bg-[#F1F1F1] relative flex flex-col md:flex-row md:space-x-5 space-y-3 md:space-y-0 p-0 max-w-sm md:max-w-6xl mx-auto">
          <div className="md:w-2/4 grid place-items-center">
            <img
              src={commitment}
              alt="Commitment"
              className="object-cover w-full h-full"
            />
          </div>
          <div className="bg-[#F1F1F1] w-full md:w-2/4 md:pt-20 pt-2 p-6 flex flex-col space-y-2 md:p-10">
            <h3 className="font-montserrat font-semibold text-black text-left pb-3 text-xl tracking-wide">
              OUR COMMITMENT
            </h3>
            <p className="text-left leading-8 font-montserrat font-medium tracking-narrow pb-5">
              We emphasize design, quality, and craftsmanship in all of our
              work. We pride ourselves in creating elegantly beautiful, unique,
              and functional aluminum installations to make your dream a
              reality. Contact us today to discuss your custom needs.
            </p>
            <Link className="text-left" to="../contact">
              <button className="bg-black hover:bg-gray-700 text-xs font-montserrat font-normal text-white py-2 px-4 w-full md:w-1/2 transform transition duration-500">
                GET IN TOUCH
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
